import React from "react";
import FeedbackForm from "./components/FeedbackForm";

function App() {
  return <FeedbackForm />;
}

export default App;
